import { render, staticRenderFns } from "./TopDualLogo.vue?vue&type=template&id=1eccd31a&scoped=true&"
import script from "@/components/TopDualLogo/TopDualLogo.ts?vue&type=script&lang=ts&"
export * from "@/components/TopDualLogo/TopDualLogo.ts?vue&type=script&lang=ts&"
import style0 from "@/components/TopDualLogo/TopDualLogo.scss?vue&type=style&index=0&id=1eccd31a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eccd31a",
  null
  
)

export default component.exports